<template>
  <div class="view-body">
      <div class="view-data">
        <div class="view-data__header">
          <h1>{{pageTitle}}</h1>
        </div>
        <div class="form" v-if="formStep == 1">
          <label>Informacje ogólne</label>
          <div class="row">
            <div class="col">
              <div class="form-group" :class="{ 'input-error': $v.name.$error && validateStep.step1 }">
                <label>Nazwa pracy*</label>
                <input class="form-control form-control-lg" type="text" v-model.trim="name"/>
                <labelInfo v-if="!$v.name.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.type.$error && validateStep.step1}">
                <label>Rodzaj zlecenia*</label>
                <vueselect :options="types" class="select--list" v-model="type" :reduce="type => type.id">
                  <template slot="selected-option" slot-scope="option">
                      {{option.name}}
                  </template>
                  <template slot="option" slot-scope="option">
                      {{option.name}}
                  </template>
                  <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                </vueselect>
                <labelInfo v-if="!$v.type.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" v-if="type == 11" :class="{ 'input-error': $v.typeOtherValue.$error && validateStep.step1 }">
                <label>Nazwa rodzaju zlecenia*</label>
                <input class="form-control form-control-lg" type="text" v-model.trim="typeOtherValue"/>
                <labelInfo v-if="!$v.typeOtherValue.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.edition.$error && validateStep.step1}">
                <label>Wydanie*</label>
                <vueselect :options="relases" class="select--list" v-model="edition" :reduce="edition => edition.value">
                  <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                </vueselect>
                <labelInfo v-if="!$v.edition.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.pagesNumber.$error && validateStep.step1}">
                <label>Liczba stron*</label>
                <input class="form-control form-control-lg" type="text" v-model="pagesNumber"/>
                <labelInfo v-if="!$v.pagesNumber.required" type="error" message="To pole jest wymagane"/>
                <labelInfo v-if="!$v.pagesNumber.numeric" type="error" message="Wartość musi być liczbą"/>
              </div>
              <div class="form-group">
                <label class="checkbox"><input type="checkbox" v-model="checkboxes.cancelLegal" @click="!checkboxes.cancelLegal ? warningPopup = true : warningPopup = false, dateLabel = 'Data obowiązywania oferty'"/><span class="checkmark"></span> Projekt wizerunkowy bez legala własnego</label>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col">
                    <label>{{dateLabel}}*</label>
                  </div>
                </div>
                <div class="row input-row">
                  <div class="col-6 input-col">
                    <div class="form-group" :class="{ 'input-error': $v.dateFrom.$error && validateStep.step1}">
                      <label>Od</label>
                      <!-- <input class="form-control form-control-lg" type="date" v-model="dateFrom"/> -->
                      <datepicker :value="dateFrom" :popperProps="popperProps" :dayStr="['7', '1', '2', '3', '4', '5', '6']" class="form-control" v-model="dateFrom" />
                      <img class ="form-group__icon" src="@/assets/symbols/calendar.svg">
                      <labelInfo v-if="!$v.dateFrom.required" type="error" message="To pole jest wymagane"/>
                      <labelInfo v-if="!$v.dateFrom.validDate" type="error" message="Data emisji mniejsza niż data druku"/>
                      <labelInfo v-if="!$v.dateFrom.validDatePast" type="error" message="Data z przeszłosci"/>
                    </div>
                  </div>
                  <div class="col-6 input-col">
                    <div class="form-group" :class="{ 'input-error': $v.dateTo.$error && validateStep.step1}">
                      <label>Do</label>
                      <!-- <input class="form-control form-control-lg" type="date" v-model="dateTo"/> -->
                      <datepicker :value="dateTo" :popperProps="popperProps" :dayStr="['7', '1', '2', '3', '4', '5', '6']" class="form-control" v-model="dateTo" />
                      <img class ="form-group__icon" src="@/assets/symbols/calendar.svg">
                      <labelInfo v-if="!$v.dateTo.required" type="error" message="To pole jest wymagane"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col">
                    <label>Termin przekazania plików do druku*</label>
                  </div>
                </div>
                <div class="row input-row">
                  <div class="col-6 input-col">
                    <div class="form-group" :class="{ 'input-error': $v.printDate.$error && validateStep.step1}">
                      <label>Data</label>
                      <!-- <input class="form-control form-control-lg" type="date" v-model="printDate"/> -->
                      <datepicker :value="printDate" :popperProps="popperProps" :dayStr="['7', '2', '2', '3', '4', '5', '6']" class="form-control" v-model="printDate" />
                      <img class ="form-group__icon" src="@/assets/symbols/calendar.svg">
                      <labelInfo v-if="!$v.printDate.required" type="error" message="To pole jest wymagane"/>
                    </div>
                  </div>
                  <div class="col-6 input-col">
                    <div class="form-group" :class="{ 'input-error': $v.printTime.$error && validateStep.step1}">
                      <label style="margin-bottom:0px">Godzina</label>
                      <!-- <input class="form-control form-control-lg" type="time" step="900" v-model="printTime" @blur="checkSeconds()"/> -->
                      <timepicker btnStr="zamknij" class="form-control form-control-lg" :popperProps="popperProps" :timeStr="['godzina', 'minuta', 'sekunda']" :value="printTime" v-model="printTime" @input="checkSeconds()" />
                      <labelInfo v-if="!$v.printTime.required" type="error" message="To pole jest wymagane"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-group" :class="{ 'input-error': $v.footer.$error && validateStep.step1}">
                <label v-if="type == 1 || type == 2">Stopka*</label>
                <label v-if="type != 1 && type != 2">Stopka</label>
                <vueselect :options="footers" class="select--list select--list--footer" label="label" :value="selectedFooter" v-model="selectedFooter" @input="setFooter">
                  <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                </vueselect>
                <labelInfo v-if="!$v.footer.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="button-group add-group" v-if="!addAddress">
                <span class="button-normal button-normal--add button-normal--small" @click="addAddress = true"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" width="100%" height="100%" xml:space="preserve">
                  <path fill="#e3000b" d="M0,0v60h60V0H0z M51,32H32v19h-4V32H9v-4h19V9h4v19h19V32z"/>
                  </svg>
                </span>
                <label class="add-label">Podaj adresy do nowej stopki</label>
              </div>
              <div class="form-group" v-if="addAddress">
                <label>Adres do stopki</label>
                <input class="form-control form-control-lg" type="text" v-model="footerAddress"/>
              </div>
              <div class="form-group" :class="{ 'input-error': $v.mediaMarktCoordinator.$error && validateStep.step1}">
                <label>Koordynator MediaMarkt*</label>
                <vueselect :options="mmCoordinatorsSelect" :value="selectedMediaMarktCoordinator" class="select--list" v-model="selectedMediaMarktCoordinator" @input="setSelected">
                  <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                </vueselect>
                <labelInfo v-if="!$v.mediaMarktCoordinator.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div class="form-group">
                <label class="checkbox"><input type="checkbox" v-model="checkboxes.sale"/><span class="checkmark"></span> Wyprzedaż</label>
              </div>
              <div class="form-group">
                <label class="checkbox"><input type="checkbox" v-model="checkboxes.installment"/><span class="checkmark"></span> Raty</label>
              </div>
          <!--<div class="form-group" v-if="checkboxes.installment">
                <label>Treść zdania prawnego</label>
                <div class="legal-preview">
                  {{legal.content}}
                </div>
              </div>-->
              <div class="form-group" v-if="expandedView" :class="{ 'input-error': $v.number.$error && validateStep.step1}">
                <label>Numer zlecenia/JOB*</label>
                <input class="form-control form-control-lg" type="text" v-model="number"/>
                <labelInfo v-if="!$v.number.numeric" type="error" message="To pole może być liczbą"/>
                <labelInfo v-if="!$v.number.required" type="error" message="To pole jest wymagane"/>
                <labelInfo v-if="!$v.number.maxLength" type="error" message="Za długi numer"/>
                <labelInfo v-if="!$v.number.minLength" type="error" message="Wymagane minimum 6 znaków"/>
                <labelInfo v-if="!$v.number.validZeros && this.number.length" type="error" message="Numer nie może zaczynać się od zera oraz składać się z samych zer"/>
              </div>
              <div class="form-group" v-if="expandedView" :class="{ 'input-error': $v.gutenbergCoordinator.$error && validateStep.step1}">
                <label>Koordynator Gutenberg*</label>
                <vueselect :options="gutCoordinators" :value="selectedGutenbergCoordinator" class="select--list" v-model="selectedGutenbergCoordinator" @input="setGutenberg">
                  <template slot="no-options">
                    <p>Brak rekordów</p>
                  </template>
                </vueselect>
                <labelInfo v-if="!$v.gutenbergCoordinator.required" type="error" message="To pole jest wymagane"/>
              </div>
            </div>
          </div>
          <div class="form-footer form-footer--add-order">
            <p class="form-footer__paragraph">* pola wymagane</p>
            <button class="button-normal button-normal--media" @click="validateStepConfirm()">Dalej</button>
          </div>
        </div>
        <div class="form" v-if="formStep == 2">
          <label>Załącz specyfikację</label>
          <div class="row">
            <div class="col">
              <div class="form-group" :class="{ 'input-error': $v.orderTechnicalSpecifications.$each[0].name.$error && validateStep.step2}">
                <label>Drukarnia/Wydawnictwo/Tytuł*</label>
                <input class="form-control form-control-lg" type="text" v-model="orderTechnicalSpecifications[0].name"/>
                <labelInfo v-if="!$v.orderTechnicalSpecifications.$each[0].name.required" type="error" message="To pole jest wymagane"/>
              </div>
              <div>
              <div class="form-group" :class="{ 'input-error': $v.orderTechnicalSpecifications.$each.$error && validateStep.step2}">
                <div class="row">
                  <label>Format w mm*</label>
                </div>
                <label>Szerokość</label>
                <input class="form-control form-control-lg" type="text" v-model="orderTechnicalSpecifications[0].width"/>
                <labelInfo v-if="!$v.orderTechnicalSpecifications.$each[0].width.required" type="error" message="To pole jest wymagane"/>
                <labelInfo v-if="!$v.orderTechnicalSpecifications.$each[0].width.numeric" type="error" message="Wartość musi być liczbą"/>
                <label>Wysokość</label>
                <input class="form-control form-control-lg" type="text" v-model="orderTechnicalSpecifications[0].height"/>
                <labelInfo v-if="!$v.orderTechnicalSpecifications.$each[0].height.required" type="error" message="To pole jest wymagane"/>
                <labelInfo v-if="!$v.orderTechnicalSpecifications.$each[0].height.numeric" type="error" message="Wartość musi być liczbą"/>
              </div>
              <div class="form-group" v-for="(item, index) in dimensions" :key="index" :class="{ 'input-error': $v.dimensions.$each[index].$error && validateStep.step2}">
                <div class="row">
                  <label>Przeformatowanie w mm</label>
                </div>
                <label>Szerokość</label>
                <input class="form-control form-control-lg" type="text" v-model="item.width"/>
                <labelInfo v-if="!$v.dimensions.$each[index].width.numeric" type="error" message="Wartość musi być liczbą"/>
                <label>Wysokość</label>
                <input class="form-control form-control-lg" type="text" v-model="item.height"/>
                <labelInfo v-if="!$v.dimensions.$each[index].height.numeric" type="error" message="Wartość musi być liczbą"/>
              </div>
              </div>
              <div class="button-group add-group">
                <span class="button-normal button-normal--add button-normal--small" @click="dimensions.push({width: '', height: ''}); checkboxes.adtionalFormat = true "><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" width="100%" height="100%" xml:space="preserve">
                  <path fill="#e3000b" d="M0,0v60h60V0H0z M51,32H32v19h-4V32H9v-4h19V9h4v19h19V32z"/>
                  </svg>
                </span>
                <label class="add-label">Dodaj przeformatowanie</label>
              </div>
              <div class="button-group add-group" v-if="checkboxes.adtionalFormat">
                <span class="button-normal button-normal--clear" @click="removeFormat()"><img src="@/assets/symbols/iks.svg" /></span>
                <label class="add-label">Usuń przeformatowanie</label>
              </div>
              <div class="form-group">
                <label>Uwagi / informacje dodatkowe</label>
                <textarea class="form-control form-control-lg form-control-textarea" type="text" v-model="orderTechnicalSpecifications[0].additionalInformation"></textarea>
              </div>
              <div class="form-group">
                <div class="file">
                  <input type="file" name="files" ref="files"  @change="handleFilesUploads()" multiple>
                  <p>Prześlij załączniki</p>
                </div>
                <ul class="files-list">
                  <li v-for="file in filesNames" >
                    <span><img src="../../assets/symbols/clip.svg" /></span>
                    <div class="button-group">
                      <p>{{file.name}}</p>
                      <span class="button-normal button-normal--clear delete-file" @click="removeFile('fileNames', file.index)"><img src="@/assets/symbols/iks.svg" /></span>
                    </div>
                  </li>
                </ul>
              </div>
              <p>* pola wymagane</p>
              <div class="form-footer form-footer--add-order">
                <button class="button-normal button-normal--cancel" @click="formStep--">Wstecz</button>
                <button class="button-normal button-normal--media" @click="validateStepConfirm()">Dalej</button>
              </div>
            </div>
            <div class="col">
            </div>
          </div>
        </div>
        <div class="form" v-if="formStep == 3">
          <div class="alert alert-danger validation-alert" v-if="error && $v.$invalid">
            W Twoim zleceniu pojawiły się niepoprawne dane, uzupełnij formularz zlecenia.
            <p></p>
            <p v-if="!$v.name.required">Nazwa pracy - pole wymagane</p>
            <p v-if="!$v.type.required">Rodzaj zlecenia - pole wymagane</p>
            <p v-if="!$v.typeOtherValue.required && $v.typeOtherValue.$error">Nazwa rodzaju zlecenia - pole wymagane</p>
            <p v-if="!$v.edition.required">Wydanie - pole wymagane</p>
            <p v-if="!$v.pagesNumber.required">Liczba stron - pole wymagane</p>
            <p v-if="!$v.pagesNumber.numeric">Liczba stron - pole musi być liczbą</p>
            <p v-if="!$v.dateFrom.validDate">Daty - data emisji mniejsza niż data druku</p>
            <p v-if="!$v.dateFrom.validDatePast">Daty - data emisji jest datą z dziś lub przeszłości</p>
            <p v-if="$v.printDate.$error">Data przekazania do druku - pole wymagane</p>
            <p v-if="$v.printTime.$error">Godzina przekazania do druku - pole wymagane</p>
            <p v-if="!$v.footer.required && $v.footer.$error">Stopka - pole wymagane</p>
            <p v-if="!$v.mediaMarktCoordinator.required">Koordynator MediaMarkt - pole wymagane</p>
            <p v-if="!$v.orderTechnicalSpecifications.$each[0].name.required">Drukarnia/Wydawnictwo/Tytuł - pole wymagane</p>
            <p v-if="!$v.orderTechnicalSpecifications.$each[0].width.required">Format szerokość - pole wymagane</p>
            <p v-if="!$v.orderTechnicalSpecifications.$each[0].width.numeric">Format szerokość - Wartość musi być liczbą</p>
            <p v-if="!$v.orderTechnicalSpecifications.$each[0].height.required">Format wysokość - pole wymagane</p>
            <p v-if="!$v.orderTechnicalSpecifications.$each[0].height.numeric">Format wysokość - Wartość musi być liczbą</p>
            <p v-if="!$v.participation.$each[0].market.required">Wybór jednostki rozliczeniowej - pole wymagane</p>
            <p v-if="!$v.participation.$each[0].percentProfit.required">Udział kosztów w % - pole wymagane</p>
            <p v-if="!isHundred">Łączny udział kosztów powinien wynosić 100%</p>
            <p v-if="!$v.participation.$each[0].nameSurname.required">Imię i nazwisko - pole wymagane</p>
          </div>
          <label>Rozliczenia</label>
          <div class="row">
            <div class="col">
              <b-container fluid>
                <div class="table--wrapper">
                  <b-table
                    class="app-table table-add-order"
                    :class="{'hide-column' : !expandedView}"
                    show-empty
                    stacked="md"
                    striped
                    :items="participation"
                    :fields="fields"
                    :paginated="false"
                    :backend-sorting="true"
                    :busy="isBusy"
                    hover>

                    <template slot="HEAD_market" slot-scope="data">
                      <div class="form-group">
                        <p class="single-table-header">{{ data.label }}*</p>
                      </div>
                    </template>

                    <template slot="HEAD_percentProfit" slot-scope="data">
                      <div class="form-group">
                        <p class="single-table-header">{{ data.label }}*</p>
                      </div>
                    </template>

                    <template slot="HEAD_nameSurname" slot-scope="data">
                      <div class="form-group">
                        <p class="single-table-header">{{ data.label }}*</p>
                        <p class="single-table-header single-table-header--small">Osoby, na którą należy zaadresować fakturę</p>
                      </div>
                    </template>

                    <template slot="HEAD_type" slot-scope="data">
                      <div class="form-group">
                        <p class="single-table-header">{{ data.label }}*</p>
                      </div>
                    </template>

                    <template slot="market" slot-scope="row">
                      <div class="form-group" :class="{ 'input-error': $v.participation.$each[row.index].market.$error && validateStep.step3}">
                        <vueselect :options="marketsSelected" label="name" class="select--list market-select" v-model="row.item.market" :reduce="market => market.id">
                          <template slot="selected-option" slot-scope="option">
                              {{option.sapNumber}} {{option.gallery_city}} {{option.number}} {{option.gallery}} {{option.category ? option.category.name : ''}}
                          </template>
                          <template slot="option" slot-scope="option">
                              {{option.sapNumber}} {{option.gallery_city}} {{option.number}} {{option.gallery}} {{option.category ? option.category.name : ''}}
                          </template>
                          <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                        </vueselect>
                        <img class ="form-group__icon" src="@/assets/symbols/search.svg">
                        <labelInfo v-if="!$v.participation.$each[row.index].market.required" type="error" message="To pole jest wymagane"/>
                      </div>
                    </template>
                    
                    <template slot="percentProfit" slot-scope="row">
                      <div class="form-group" :class="{ 'input-error': !isHundred && row.item.percentProfit != '' ||  $v.participation.$each[row.index].percentProfit.$error && validateStep.step3}">
                        <input class="form-control form-control-lg" type="text" v-model="row.item.percentProfit" @blur="row.item.percentProfit = row.item.percentProfit + ' %'; checkSum()" @focus="row.item.percentProfit = row.item.percentProfit.replace(' %','');"/>
                        <labelInfo v-if="!isHundred && row.item.percentProfit != ''" type="error" message="Łączny udział kosztów, powinien wynosić 100%"/>
                        <labelInfo v-if="!$v.participation.$each[row.index].percentProfit.required" type="error" message="To pole jest wymagane"/>
                      </div>
                    </template>

                    <template slot="nameSurname" slot-scope="row">
                      <div class="form-group" :class="{ 'input-error': $v.participation.$each[row.index].nameSurname.$error && validateStep.step3}">
                        <input class="form-control form-control-lg" type="text" v-model="row.item.nameSurname"/>
                        <labelInfo v-if="!$v.participation.$each[row.index].nameSurname.required" type="error" message="To pole jest wymagane"/>
                      </div>
                    </template>

                    <template slot="settlement" slot-scope="row">
                      <div class="form-group" v-if="expandedView" :class="{ 'input-error': $v.participation.$each[row.index].type.$error && validateStep.step3}">
                        <vueselect :options="settlements" label="name" class="select--list" v-model="row.item.type" :reduce="settlement => settlement.id">
                          <template slot="no-options">
                             <p>Brak rekordów</p>
                          </template>
                        </vueselect>
                        <labelInfo v-if="!$v.participation.$each[row.index].type.required" type="error" message="To pole jest wymagane"/>
                      </div>
                    </template>

                    </b-table>
                    <span class="button-normal button-normal--add add-row" @click="participation.push({market: '', percentProfit: '', nameSurname: ''})"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" width="100%" height="100%" xml:space="preserve">
                      <path fill="#e3000b" d="M0,0v60h60V0H0z M51,32H32v19h-4V32H9v-4h19V9h4v19h19V32z"/>
                      </svg>
                    </span>
                    <span v-if="participation.length > 1" class="button-normal button-normal--add add-row remove-row" @click="removeParticipation()"><img src="@/assets/symbols/iks.svg" /><div class="order-tooltip order-tooltip--edit">usuń</div></span>
                </div>
              </b-container>
              <div v-if="expandedView" class="addtional-options">
                <div class="form-group">
                  <label class="checkbox"><input type="checkbox" v-model="checkboxes.express"/><span class="checkmark"></span> Zlecenie realizowane w trybie ekspresowym</label>
                  <b-container fluid>
                    <div class="table--wrapper">
                      <b-table
                        class="app-table table-add-order"
                        show-empty
                        stacked="md"
                        striped
                        :items="modifications"
                        :fields="modificationsFields"
                        :paginated="false"
                        :busy="isBusy"
                        hover>

                        <template slot="corrects" slot-scope="row">
                          <div class="form-group" :class="{ 'input-error': $v.modifications.$each.$error && validateStep.step3}">
                            <input class="form-control form-control-lg" type="text" v-model="row.item.corrects"/>
                            <labelInfo v-if="!$v.modifications.$each.corrects" type="error" message="Wartość musi być liczbą"/>
                          </div>
                        </template>

                        <template slot="modifications" slot-scope="row">
                          <div class="form-group" :class="{ 'input-error': $v.modifications.$each.$error && validateStep.step3}">
                            <input class="form-control form-control-lg" type="text" v-model="row.item.modifications"/>
                            <labelInfo v-if="!$v.modifications.$each.modifications" type="error" message="Wartość musi być liczbą"/>
                          </div>
                        </template>

                      </b-table>
                    </div>
                  </b-container>
                </div>
              </div>
              <p>* pola wymagane</p>
              <div class="form-footer form-footer--add-order">
                <button class="button-normal button-normal--cancel" @click="formStep--">Wstecz</button>
                <div class="button-group button-group--column">
                  <button class="button-normal button-normal--media" @click="onSubmit()">Wyślij zlecenie</button>
                  <button class="button-normal button-normal--cancel" @click="$router.push('/dashboard');">Anuluj zlecenie</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <popup 
        v-if="warningPopup"
        title="WAŻNE!"
        title2="WPROWADŹ SWOJE HASŁO DO SYSTEMU, ABY POTWIERDZIĆ ZAZNACZENIE TEGO POLA." 
        text="Zaznaczenie tego pola spowoduje, że z reklamy zostanie usunięty zapis prawny obligatoryjny w przypadku podania ceny.
        Może wiązać się to z negatywnymi skutkami prawnymi w postaci m.in kar finansowych. Zaznaczając to pole, Market (lub odpowiedzialny dział‚ MSHP lub MS online)
        decyduje się na poniesienie ewentualnych skutków prawnych i finansowych w pełnej wysokości." 
        cancelButton="Anuluj" 
        confirmButton="Potwierdź" 
        input="true"
        :inputInvalid="badLogin"
        inputInvalidText="Hasło nieprawidłowe"
        placeholder="Hasło"
        v-model="password"
        @confirmed="cancelLegal()"
        @canceled="warningPopup = false, checkboxes.cancelLegal = false, badLogin = false"/>
  </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import labelInfo from '@/components/blocks/labelInfo.vue'
import popup from '@/components/blocks/popup'
import { mixin as clickaway } from 'vue-clickaway';

const touchMap = new WeakMap()

export default {
  name: 'OrderAdd',
  components:{

    labelInfo,
    popup,
    

  },
  mixins: [validationMixin, clickaway],
  data () {
    return {

      error: false,

      pageTitle: 'Nowe zlecenie',

      marketsSelected: [],
      isBusy: false,
      expandedView: false,
      save: false,

      legal: '',
      password: '',
      files:'',
      filesNames: [],
      formData: '',
      orderFiles: '',
      dateLabel: 'Data obowiązywania oferty',
      selectedMediaMarktCoordinator: null,
      selectedGutenbergCoordinator: {
        value: '',
        label: ''
      },

      popperProps: {
          arrowPosition: 'start',
          arrowOffsetScaling: 1,
          popperOptions: {
              placement: 'bottom-start',
              positionFixed: true,
              modifiers: {
                  flip: {
                      behavior: ['left', 'right', 'bottom', 'top']
                  },
                  preventOverflow: {
                      boundariesElement: document.querySelector('.hot-module__body'),
                  },
              },
          },
      },

      showList: false,
      badLogin: false,
      warningPopup: false,
      isHundred: false,
      addAddress: false,

      specyficationId: null,
      
      fields: [
          {
            key: 'market', 
            label: 'Wybór jednostki rozliczeniowej' 
          },
          {
            key: 'percentProfit', 
            label: 'Udział kosztów w %' 
          },
          {
            key: 'nameSurname', 
            label: 'Imię i nazwisko' 
          },
          {
            key: 'settlement', 
            label: 'Sposób rozliczenia' 
          },
        ],

      participation: [
        {
          market: '',
          percentProfit: '',
          nameSurname: '',
          type: '',
        }
      ],

      dimensions:[],
      
        name: '',
        type: '',
        edition: '',
        number:'',
        pagesNumber: '',
        dateFrom: '',
        dateTo: '',
        printDate: '',
        printTime: '',
        footer: '',
        footerAddress: '',
        mediaMarktCoordinator: '',
        gutenbergCoordinator: '',
        title: '',
        width: '',
        height: '',
        info: '',
        orderSettlements:[this.participation],
        orderTechnicalSpecifications: [
          {
            name: '',
            width: '',
            height: '',
            additionalInformation: '',
            orderTechnicalSpecificationReformattedSizes: [],
          }
        ],
        typeOtherValue: '',
      

      checkboxes:{
        cancelLegal: false,
        sale: false,
        installment: false,
        adtionalFormat: false,
        express: false,
      },

      types:[],

      settlements:[
        {id: 1, name:'wg cennika'},
        {id: 2, name:'godzinowe'},
      ],

       relases:[
        {value:'1', label:'Centralne'},
        {value:'2', label:'Lokalne'},
      ],

      mmCoordinators:[],
      mmCoordinatorsSelect: [],
      gutCoordinators:[],
      markets: [],
      footers: [],
      selectedFooter:{
            value: '',
            label: ''
          },
      showList: false,
      search: '',
      formStep: 1,

      modificationsFields: [
          {
            key: 'corrects', 
            label: 'Liczba dodatkowych korekt' 
          },
          {
            key: 'modifications', 
            label: 'Liczba modyfikacji' 
          },
        ],

      modifications:[
        {
          corrects: '0',
          modifications: '0',
        }
      ],

      exist: false,

      validateStep:{
        step1: false,
        step2: false,
        step3: false,
      }

    }
  },
  validations: {

        name: {
          required,
        },
        type: {
          required,
        },
        edition: {
          required,
        },
        number: {
          numeric,
          required,
          maxLength: maxLength(10),
          minLength: minLength(6),
          validZeros (){
            return this.validZeros();
          }
        },
        pagesNumber: {
          required,
          numeric,
        },
        dateFrom: {
          required,
          validDate (){
            return this.validDate();
          },
          validDatePast(){
            return this.validDatePast();
          },
        },
        dateTo: {
          required,
        },
        printDate: {
          required,
        },
        printTime: {
          required,
        },
        footer:{
          isBillboard (){
            return this.isBillboard();
          },
        },
        typeOtherValue:{
          isType (){
            return this.isType();
          },
        },
        mediaMarktCoordinator: {
          required,
        },
        gutenbergCoordinator: {
          required,
        },
        orderTechnicalSpecifications:{
          $each:{
            name:{
              required,
            },
            width:{
              required,
              numeric,
            },
            height:{
              required,
              numeric,
            }
          }
        },
        dimensions:{
          $each:{
            width:{
              numeric,
            },
            height:{
              numeric,
            }
          }
        },
        participation:{
          $each:{
            market:{
              required,
            },
            nameSurname:{
              required,
            },
            percentProfit:{
              required,
            },
            type:{
              required,
            }
          }
        },
        modifications:{
          $each: {
            corrects:{
              numeric,
            },
            modifications:{
              numeric,
            }
          }
        },

  },
  methods:{

    validZeros(){

      const num = this.number.toString();

      if (num.charAt(0) === '0'){
        return false;
      }

      let sum = 0;

      [...num].forEach((char) => {

        char = parseInt(char);
        sum += char;

      });

      if (sum <= 0){
        return false;
      }

      return true;

    },

    getGutCoordinators(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('users/users', {
        params:{
          'company' : 1,
          'limit' : 100,
        },
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }}).then(response => {

          response.data.list.forEach((value) => {
            this.gutCoordinators.push({value: value.id, label: `${value.name} ${value.surname}`});
          });

        })
        .catch(error =>{
          console.error(error.response);
        })

    },

    removeFile(listType, id){

      if(listType == 'fileNames'){

        let count = this.filesNames.length;
        this.formData.delete('files['+id+']')
        this.filesNames = this.filesNames.filter(o => o.index !== id);

      }

    },

    addParticipation(){

      const token = localStorage.getItem('auth_token');

      const settlement ={
        market: '',
        percentProfit: '',
        nameSurname: '',
        type: ''
      }

      this.$http.post(`orders/${this.id}/adds/settlements`, settlement, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }
        })
        .then(response => {

          const id = response.data.settlement.id;
          this.participation.push({id: id, market: '', percentProfit: '', nameSurname: '', type: ''});

        })
        .catch(error =>{

            console.error(error.response);

        })

    },

    removeParticipation(){

      const index =  this.participation.length >= 1 ? this.participation.length -1 : 0;
      this.participation.splice(index, 1);
      this.checkSum();

    },

    addFormat(){

      const token = localStorage.getItem('auth_token');

      const format = {width: '', height: ''};

      this.$http.put(`order-technical-specifications/${this.specificationId}/add/reformatted/size`, format, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }
        })
        .then(response => {

          const id = response.data.reformattedSize.id;
          this.dimensions.push({id: id, width: '', height: ''}); 
          this.checkboxes.adtionalFormat = true

        })
        .catch(error =>{

            console.error(error.response);

        })

    },

    removeFormat(){

      this.dimensions = this.dimensions.filter(item => item !== this.dimensions[this.dimensions.length - 1]);
      if (this.dimensions.length < 1) this.checkboxes.adtionalFormat = false

    },

    setFooter(selected) {
      selected ? this.footer = selected.value : this.footer = '';
    },

    setGutenberg(selected) {
      this.gutenbergCoordinator = selected.value;
    },
    

    isBillboard(){
      
      if(this.type == 1 || this.type == 2){

        if(this.footer != ''){
          return true;
        }

        return false;

      }

      return true;

    },

    isType(){
      
      if(this.type == 11){

        if(this.typeOtherValue != ''){
          return true;
        }

        return false;

      }

      return true;

    },

    validDate(){
      
      const d1 = new Date(this.dateFrom).getTime();
      const d2 = new Date(this.printDate).getTime();

      if(d1 < d2){
        return false
      }else{
        return true
      }

    },

    validDatePast(){
      
      const today = new Date().getTime();
      const d1 = new Date(this.dateFrom).getTime();

      if(d1 >= today){
        return true;
      }

      return false;

    },

    validateStepConfirm(){

      this.validateStep.step1 = false;
      this.validateStep.step2 = false;
      this.validateStep.step3 = false;

      if(this.formStep == 1){

        this.validateStep.step1 = true;

      }

      if(this.formStep == 2){

        this.validateStep.step2 = true;
        
      }

      if(this.formStep == 3){

        this.validateStep.step3 = true;
        
      }

      this.$v.$touch();

      const inputs = document.querySelectorAll('.form-group');
      let valid;

      window.setTimeout(() =>{

        if(document.querySelector('.input-error')){


        }else{

          valid = true;

        }

        if(valid){

          if(this.formStep != 3){
          
            this.formStep++;

          }

          if(this.save){
            this.createOrderJson();
          }

        }

      }, 100)

    },

    getFormData(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('order/form/data', {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.types = response.data.type;

        })
        .catch(error =>{

            console.error(error.response);

        })

    },

    checkSeconds(){

      if(this.printTime){

        let time = this.printTime.split(':');
        let hour = time[0];
        let seconds = time[1];

        if(seconds > 0 && seconds < 15){
          seconds = '15';
        }

        if(seconds > 15 && seconds < 30){
          seconds = '30';
        }

        if(seconds > 30 && seconds < 45){
          seconds = '45';
        }

        if(seconds > 45 && seconds < 60){
          seconds = '00';
          hour++;
        }

        this.printTime = `${hour}:${seconds}:00`;

      }
      
    },

    setSelected(selected) {
      this.mediaMarktCoordinator = selected.value;
    },

    dropList(event){

      let parent = event.currentTarget.parentElement
      let list = parent.querySelector('.list-group--form');
      let search = parent.querySelector('.search');
      let display = parent.querySelector('.sub-markets-display');

      if(list.style.display == "none"){
        list.style.display = "block";
        search.style.display = "block";
        display.style.display = "none";
      }else{
        list.style.display = "none";
        search.style.display = "none";
        display.style.display = "block";
      }

    },

    upList(event){

      let parent = event.currentTarget.parentElement.parentElement
      let list = parent.querySelector('.list-group--form');
      let search = parent.querySelector('.search');
      let display = parent.querySelector('.sub-markets-display');

      if(list.style.display == "none"){
        list.style.display = "block";
        search.style.display = "block";
        display.style.display = "none";
      }else{
        list.style.display = "none";
        search.style.display = "none";
        display.style.display = "block";
      }

    },

    handleFilesUploads(){

      if(this.formData == ''){

        this.formData = new FormData();

      }

      this.files = this.$refs.files.files;

      for( var i = 0; i < this.files.length; i++ ){

          let file = this.files[i];
          let index = this.filesNames.length + i+1;

          this.filesNames.push({name: file.name, index: index})
          this.formData.append('files[' + index + ']', file);
          
      }

    },

    prepareFiles(){

      this.specyficationId ? this.addFiles(this.formData) : console.error('No order id found');

    },

    getLegal(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('legal-sentences/2', {headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
        } }).then(response => {

          this.legal = response.data;

        })

    },

    getMarkets(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('market/markets', {
        params:{

          'limit': 100,

        },
        headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
        } }).then(response => {

          this.markets = response.data.list;

          this.markets.forEach(element => {

            this.marketsSelected.push({
              id: element.id,
              name: `${element.sapNumber} ${element.gallery_city} ${element.number} ${element.gallery} ${element.category}`,
              sapNumber: element.sapNumber,
              gallery_city: element.gallery_city,
              number: element.number,
              gallery: element.gallery,
              category: element.category ? element.category: ''
            })
            
          });

        })

    },

    getMmCoordinators(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('users/users', {
        params:{
          'company' : 2,
          'limit' : 100
        },
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }}).then(response => {
          let _this = this;

          let list = response.data.list;
          this.mmCoordinators = response.data.list;

          list.forEach((item) => {
            _this.mmCoordinatorsSelect.push( { value: item.id, label: item.name + ' ' + item.surname } )
          });

           if(this.$parent.grantPermission(['ROLE_CENTRAL', 'ROLE_LOCAL'])){
           
            let user = this.getDataFromStorage('user');

              this.selectedMediaMarktCoordinator = {
                value: user.id,
                label: user.name +' '+ user.surname,
              }

              this.mediaMarktCoordinator = user.id

           }

        })
        .catch(error =>{
          console.error(error.response);
        })

    },

    getFooters(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('footer', {
        params:{

          'limit' : 100,
          'sort' : 'ASC',
          'sort_field' : 'articleNumber',

        },
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }}).then(response => {

          response.data.list.forEach((value) => {
            this.footers.push({value: value.id, label: `${value.articleNumber} ${value.content}`});
          });

        })
        .catch(error =>{
          console.error(error.response);
        })

    },

    marketData(id){

      let market = this.markets.find(o => o.id === id);

      if(market){

        return `${market.sapNumber} ${market.name} ${market.city} ${market.gallery} `;

      }

      return '';

    },

    checkSum(){

      let sum = 0;

      for (var item of this.participation) {
        
        let raw = item.percentProfit.replace(',','.');
        sum += Math.round(parseFloat(raw.replace('%',''))* 100) / 100;

      }

      sum == 100 ? this.isHundred = true : this.isHundred = false;

    },

    cancelLegal(){

      let data = {
          'username': this.$parent.$refs.head.user.email,
          'password': this.password
        }

      this.$http.post('login_check', data).then(response => {

            this.dateLabel = 'Data emisji';
            this.warningPopup = false;
            this.checkboxes.cancelLegal = true;

        }).catch(error => {

          if(error.response.status === 401) {
            
            this.checkboxes.cancelLegal = false;
            this.badLogin = true;

          }else{

            console.error(error.response);

          }

        })

    },

    onSubmit(){

      this.save = true;
      this.validateStepConfirm();

    },

   createOrderJson(){

      this.isBusy = true;

        const orderForPrinting = `${this.printDate} ${this.printTime}`;

        for (var item of this.participation) {
          
          item.percentProfit = item.percentProfit.replace(',','.');
          item.percentProfit = Math.round(parseFloat(item.percentProfit.replace('%',''))* 100) / 100;

        }

        this.orderTechnicalSpecifications[0].orderTechnicalSpecificationReformattedSizes = this.dimensions;

        let order = {
          mediaMarktCoordinator: this.mediaMarktCoordinator,
          gutenbergCoordinator: this.gutenbergCoordinator,
          name: this.name,
          type: this.type,
          number: this.number,
          footer: this.footer,
          footerAddress: this.footerAddress,
          edition: this.edition,
          pagesNumber: this.pagesNumber,
          sale: this.checkboxes.sale,
          installment: this.checkboxes.installment,
          sentence: this.legal.id,
          legalSentenceContent : this.legal.content,
          withoutOwnLegal: this.checkboxes.cancelLegal,
          offerFrom: this.dateFrom,
          offerTo: this.dateTo,
          orderForPrinting: orderForPrinting,
          oldestPageStatus: 1,
          parent: null,
          isExpress: this.checkboxes.express,
          isAllowedStatusesForPages: 0,
          secondType: 1,	
          isEdited: 0,
          editedLastTime: '',
          orderSettlements : this.participation,
          orderTechnicalSpecifications: this.orderTechnicalSpecifications,
          typeOtherValue: this.typeOtherValue,
          numberOfCorrections: this.modifications[0].corrects,
          numberOfModify: this.modifications[0].modifications,
          addBaseSpecification: true
        };

        if(this.isHundred){
        
          this.addOrder(order);
          return;

        }else{

          this.participation.forEach(row => {

            if(row.percentProfit !='undefined %' && row.percentProfit != ''){

              row.percentProfit = row.percentProfit + ' %';

            }
            
            if(row.percentProfit =='undefined %'){

              row.percentProfit = '';

            }
        
          });

        }

        this.isBusy = false;

    },

    addOrder(order){

        const token = localStorage.getItem('auth_token');

        this.$http.post('orders', order, {
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

          }}).
          then(response => {

            if(this.files){

              this.specyficationId = response.data.order.technicalSpecifications.id;
              this.prepareFiles();

            }else{

              if(this.expandedView){
              
                this.updateOrder(order, response.data.order.id);

              }else{

                this.isBusy = false;
                this.$router.push('/dashboard');

              }

            }

          })
          .catch(error => {

                console.error(error.response);
                this.isBusy = false;

                this.participation.forEach(row => {

                  if(row.percentProfit !='undefined %' && row.percentProfit != ''){

                    row.percentProfit = row.percentProfit + ' %';

                  }
                  
                  if(row.percentProfit =='undefined %'){

                    row.percentProfit = '';

                  }
        
                });

          })

    },

    updateOrder(order, id){

        const token = localStorage.getItem('auth_token');

        this.$http.put(`orders/${id}/accept`, order, {
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

          }}).
          then(response => {

            this.isBusy = false;
            this.$router.push('/dashboard');

          })
          .catch(error => {

                console.error(error.response);
                this.isBusy = false;
                this.submitError = true;

                this.participation.forEach(row => {

                  if(row.percentProfit !='undefined %' && row.percentProfit != ''){

                    row.percentProfit = row.percentProfit + ' %';

                  }
                  
                  if(row.percentProfit =='undefined %'){

                    row.percentProfit = '';

                  }
        
                });

          })

    },

    addFiles(formData){

        const token = localStorage.getItem('auth_token');

        this.$http.post(`order-specification-files/${this.specyficationId}`, formData, {
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'

          }}).
          then(response => {

            this.$router.push('/dashboard');
            this.isBusy = false;

          })
          .catch(error => {

                console.error(error.response);
                this.isBusy = false;
                this.participation.forEach(row => {

                  if(row.percentProfit !='undefined %' && row.percentProfit != ''){

                    row.percentProfit = row.percentProfit + ' %';

                  }
                  
                  if(row.percentProfit =='undefined %'){

                    row.percentProfit = '';

                  }
        
                });

          })

    },

  },
  mounted(){

    this.getFormData();
    this.getMarkets();
    this.getFooters();
    this.getLegal();
    this.getMmCoordinators();
    this.getGutCoordinators();

    let user = this.getDataFromStorage('user');

    if(user.roles[0] == 'ROLE_ADMIN' || user.roles[0] == 'ROLE_COORDINATOR'){

      this.selectedGutenbergCoordinator.value = user.id;
      this.selectedGutenbergCoordinator.label = user.name +' '+ user.surname;
      this.gutenbergCoordinator = user.id;
      this.expandedView = true;

    }

  },
};
</script>

<style lang="scss" scoped>

.form{
  width:50%;
  padding: 10px;
}

.list-group--form{
  max-height: 150px;
  width:92%;
  overflow: hidden;
  overflow-y: scroll;
  position: absolute;
  display: none;
}

.form-footer{
  display:flex;
  width:100%;
  justify-content: space-between;
}

.sub-markets-display{
  display:flex;
  overflow:hidden;
  position: relative;

  &__body{
    display:flex;
    flex-direction: row;
    align-participation: center;
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height: 150%;
    overflow:hidden;
    overflow-x: scroll;
    white-space: nowrap;
    border-right: 30px #f8f8f8 solid;

    & ul{
      padding: 0;
      margin:0;
      position: relative;
    }

    & li{
      display: inline-block;
    }
  }
}

.legal-preview{
  padding: 1rem;
  border-radius: 5px;
  background:rgba(255,229,229,0.65);
}

.file{
    display:flex;
    position:relative;
    justify-content: center;
    align-participation: center;
    flex-direction: column;
    border: 2px dashed rgb(214, 214, 214);
    height:100px;
    transition-duration: 0.2s;
    background:none;

    &:hover{
        opacity:0.5;
        transition-duration: 0.2s;
        background:rgb(235, 235, 235);
    }
}

.file p{
  width: 100%;
  text-align: center;
}

.file input{
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}

.search{
  display:none;
}

.add-label{
  margin:0;
  margin-left: 10px;
}

.add-group{
  margin:20px 0px;
}

.single-table-header{
  &--small{
    font-size: 10px;
    width:60%;
  }
}

.add-row{
  position:absolute;
  right:-50px;
  bottom:15px;
}

.form-control-textarea {

    min-height: 100px;
    line-height: 30px;
    resize: none;
    padding: 0 1rem;

    background: linear-gradient(
      to bottom,
      transparent,
      transparent 29px,
      #E4EAEE 1px,
      #E4EAEE
    );
    border-bottom: none;
    background-size: 100% 30px;

    &:focus {
      outline: none;
      border:none;
      box-shadow: none;
    }

  }

.validation-alert{

  & p{
    margin: 10px 0px;
    font-weight: 700;
  }
}

.form-group.input-error > input {
  height: auto !important;
  padding-bottom: 0 !important;
}

.form-group.input-error > .form-control {
  height: auto !important;
  padding-bottom: 0 !important;
  border-bottom: 2px #e3000b solid !important;
  transition: all 0.2s ease;
}

.remove-row{
  right:-110px;

  &:hover .order-tooltip{
    visibility: visible;
  }
}

.addtional-options{
  width: 50%;
  margin: 5% 0%;

  & label{
    padding:5% 0%;
  }
}

</style>
